"use strict";

var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BridgeSDK = void 0;
var providers_1 = require("@ethersproject/providers");
var ethers_1 = require("ethers");
var lodash_1 = require("lodash");
var p_all_1 = __importDefault(require("p-all"));
var js_logger_1 = __importDefault(require("js-logger"));
var BlockHeaderRegistry_json_1 = require("./abi/BlockHeaderRegistry.json");
var TokenBridge_json_1 = require("./abi/TokenBridge.json");
var SignUtils = __importStar(require("./utils"));
var ethers_multicall_1 = require("ethers-multicall");
(0, ethers_multicall_1.setMulticallAddress)(122, '0x3CE6158b7278Bf6792e014FA7B4f3c6c46fe9410');
(0, ethers_multicall_1.setMulticallAddress)(42220, '0xa27A0C40A0a17485c11d1f342a95c946E9523551');
var DEFAULT_BRIDGES = {
  1: ethers_1.ethers.constants.AddressZero
};
var BridgeSDK = /*#__PURE__*/_createClass(function BridgeSDK(registryAddress) {
  var _this = this;
  var bridges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var registryBlockFrequency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var registryRpc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'https://rpc.fuse.io';
  var multicalls = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var rpcs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
  var logger = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : js_logger_1.default;
  _classCallCheck(this, BridgeSDK);
  this.rpcs = undefined;
  this.getChainRpc = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(chainId) {
      var _a, blockchains, blockchain, rpcs, randomRpc;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.rpcs) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return _this.registryContract.getRPCs();
          case 3:
            blockchains = _context.sent;
            blockchains.forEach(function (_) {
              return _.chainId = _.chainId.toNumber();
            });
            _this.rpcs = blockchains;
          case 6:
            blockchain = (_a = _this.rpcs.find(function (_) {
              return _.chainId === chainId;
            })) === null || _a === void 0 ? void 0 : _a.rpc;
            rpcs = blockchain.split(',').filter(function (_) {
              return _.includes('ankr') === false;
            });
            randomRpc = rpcs[(0, lodash_1.random)(0, rpcs.length - 1)];
            return _context.abrupt("return", new ethers_1.ethers.providers.JsonRpcBatchProvider(randomRpc));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  this.getBridgeContract = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(chainId, provider) {
      var rpc, bridgeAddress;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(provider !== null && provider !== void 0)) {
              _context2.next = 4;
              break;
            }
            _context2.t0 = provider;
            _context2.next = 7;
            break;
          case 4:
            _context2.next = 6;
            return _this.getChainRpc(chainId);
          case 6:
            _context2.t0 = _context2.sent;
          case 7:
            rpc = _context2.t0;
            bridgeAddress = _this.bridges[chainId];
            return _context2.abrupt("return", new ethers_1.ethers.Contract(bridgeAddress, TokenBridge_json_1.abi, rpc));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  this.getCheckpointBlockFromEvents = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(sourceChainId, checkpointBlockNumber) {
      var f, events, bestCheckpoint;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            f = _this.registryContract.filters['BlockAdded'](null, sourceChainId, checkpointBlockNumber);
            _context3.next = 3;
            return _this.registryContract.queryFilter(f, -1e6);
          case 3:
            events = _context3.sent;
            bestCheckpoint = (0, lodash_1.maxBy)(Object.values((0, lodash_1.groupBy)((0, lodash_1.uniqBy)(events, function (_) {
              return _.args.validator;
            }), function (_) {
              return _.args.payload;
            })), function (_) {
              return _.length;
            });
            _this.logger.debug('getCheckpointBlockFromEvents', {
              sourceChainId: sourceChainId,
              checkpointBlockNumber: checkpointBlockNumber,
              bestCheckpoint: bestCheckpoint,
              checkpointArgs: bestCheckpoint[0].args
            });
            return _context3.abrupt("return", bestCheckpoint && {
              signatures: bestCheckpoint.map(function (_) {
                return _.args.signature;
              }),
              cycleEnd: bestCheckpoint[0].args.cycleEnd,
              validators: bestCheckpoint[0].args.validators
            });
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  this.getBlocksToSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(sourceChainId, minTxBlockNumber, maxTxBlockNumber, targetBridgeContract) {
      var getCheckpointFromEvents,
        sourceTxBlockHash,
        signedCheckPoint,
        checkPointBlockNumber,
        parentAndCheckpointBlocks,
        checkpointBlock,
        signedBlock,
        _args4 = arguments;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            getCheckpointFromEvents = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : true;
            _context4.next = 3;
            return targetBridgeContract.chainVerifiedBlocks(sourceChainId, maxTxBlockNumber);
          case 3:
            sourceTxBlockHash = _context4.sent;
            checkPointBlockNumber = maxTxBlockNumber + (_this.registryBlockFrequency - maxTxBlockNumber % _this.registryBlockFrequency);
            if (!(!sourceTxBlockHash || sourceTxBlockHash === ethers_1.ethers.constants.HashZero)) {
              _context4.next = 18;
              break;
            }
            if (!getCheckpointFromEvents) {
              _context4.next = 12;
              break;
            }
            _context4.next = 9;
            return _this.getCheckpointBlockFromEvents(sourceChainId, checkPointBlockNumber).catch(function (e) {
              console.warn('getCheckpointBlockFromEvents', e);
              return undefined;
            });
          case 9:
            signedCheckPoint = _context4.sent;
            _context4.next = 15;
            break;
          case 12:
            _context4.next = 14;
            return _this.registryContract.getSignedBlock(sourceChainId, checkPointBlockNumber).catch(function (e) {
              console.warn('getSignedBlock', e);
              return false;
            });
          case 14:
            signedCheckPoint = _context4.sent;
          case 15:
            _this.logger.debug('got checkpoint block:', {
              checkPointBlockNumber: checkPointBlockNumber,
              getCheckpointFromEvents: getCheckpointFromEvents,
              signedCheckPoint: signedCheckPoint
            });
            if (signedCheckPoint) {
              _context4.next = 18;
              break;
            }
            throw new Error("checkpoint block ".concat(checkPointBlockNumber, " does not exists yet"));
          case 18:
            _context4.next = 20;
            return _this.getChainBlockHeaders(sourceChainId, minTxBlockNumber, checkPointBlockNumber);
          case 20:
            parentAndCheckpointBlocks = _context4.sent;
            parentAndCheckpointBlocks.forEach(function (b) {
              return _this.logger.debug('getBlocksToSubmit parentAndCheckpointBlocks:', b);
            });
            checkpointBlock = (0, lodash_1.last)(parentAndCheckpointBlocks);
            signedBlock = {
              chainId: sourceChainId,
              rlpHeader: checkpointBlock.rlpHeader,
              signatures: signedCheckPoint ? signedCheckPoint.signatures : [],
              cycleEnd: signedCheckPoint ? signedCheckPoint.cycleEnd : 0,
              validators: signedCheckPoint ? signedCheckPoint.validators : []
            };
            return _context4.abrupt("return", {
              checkPointBlockNumber: checkPointBlockNumber,
              signedBlock: signedBlock,
              parentAndCheckpointBlocks: parentAndCheckpointBlocks
            });
          case 25:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x6, _x7, _x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
  this.getChainBlockHeaders = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(sourceChainId, startBlock, endBlock) {
      var rpc, blocks;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this.getChainRpc(sourceChainId);
          case 2:
            rpc = _context5.sent;
            _context5.next = 5;
            return (0, p_all_1.default)((0, lodash_1.range)(startBlock, endBlock + 1).map(function (i) {
              return function () {
                return rpc.send('eth_getBlockByNumber', [ethers_1.ethers.utils.hexValue(i), false]);
              };
            }), {
              concurrency: 50
            });
          case 5:
            blocks = _context5.sent;
            _this.logger.debug('getChainBlockHeaders', {
              sourceChainId: sourceChainId,
              startBlock: startBlock,
              endBlock: endBlock,
              fetchedBlocks: blocks.length
            });
            return _context5.abrupt("return", blocks.map(function (_) {
              return SignUtils.prepareBlock(_, sourceChainId);
            }));
          case 8:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x10, _x11, _x12) {
      return _ref5.apply(this, arguments);
    };
  }();
  this.submitBlocksAndExecute = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(sourceChainId, targetChainId, receiptProofs, signer) {
      var targetBridgeContract, minBlockReceipt, maxBlockReceipt, _yield$_this$getBlock, checkPointBlockNumber, signedBlock, parentAndCheckpointBlocks, blockToReceipts, mptProofs, parentRlps;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _this.getBridgeContract(targetChainId);
          case 2:
            targetBridgeContract = _context6.sent;
            minBlockReceipt = (0, lodash_1.minBy)(receiptProofs, function (_) {
              return Number(_.receipt.blockNumber);
            });
            maxBlockReceipt = (0, lodash_1.maxBy)(receiptProofs, function (_) {
              return Number(_.receipt.blockNumber);
            });
            _context6.next = 7;
            return _this.getBlocksToSubmit(sourceChainId, Number(minBlockReceipt.receipt.blockNumber), Number(maxBlockReceipt.receipt.blockNumber), targetBridgeContract).catch(function (e) {
              throw new Error("getBlocksToSubmit failed: ".concat(e.message));
            });
          case 7:
            _yield$_this$getBlock = _context6.sent;
            checkPointBlockNumber = _yield$_this$getBlock.checkPointBlockNumber;
            signedBlock = _yield$_this$getBlock.signedBlock;
            parentAndCheckpointBlocks = _yield$_this$getBlock.parentAndCheckpointBlocks;
            _this.logger.debug('submitBlocksAndExecute got blocks to submit:', {
              checkPointBlockNumber: checkPointBlockNumber,
              signedBlock: signedBlock,
              parentAndCheckpointBlocks: parentAndCheckpointBlocks.length,
              receiptProofs: receiptProofs
            });
            blockToReceipts = (0, lodash_1.groupBy)(receiptProofs, function (_) {
              return Number(_.receipt.blockNumber);
            });
            mptProofs = Object.entries(blockToReceipts).map(function (_ref7) {
              var _ref8 = _slicedToArray(_ref7, 2),
                k = _ref8[0],
                receiptProofs = _ref8[1];
              var txBlock = parentAndCheckpointBlocks.find(function (_) {
                return Number(_.block.number) === Number(k);
              });
              return {
                blockNumber: Number(k),
                blockHeaderRlp: txBlock.rlpHeader,
                receiptProofs: receiptProofs.map(function (receiptProof) {
                  return {
                    expectedRoot: receiptProof.receiptsRoot,
                    expectedValue: receiptProof.receiptRlp,
                    proof: receiptProof.receiptProof,
                    key: SignUtils.index2key(receiptProof.txIndex, receiptProof.receiptProof.length),
                    keyIndex: 0,
                    proofIndex: 0
                  };
                })
              };
            });
            parentAndCheckpointBlocks.pop();
            parentRlps = parentAndCheckpointBlocks.map(function (_) {
              return _.rlpHeader;
            }).reverse();
            mptProofs.forEach(function (proof) {
              return _this.logger.debug('submitBlocksAndExecute proof:', JSON.stringify(proof));
            });
            return _context6.abrupt("return", targetBridgeContract.connect(signer).submitChainBlockParentsAndTxs(signedBlock, checkPointBlockNumber, parentRlps, mptProofs));
          case 18:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x13, _x14, _x15, _x16) {
      return _ref6.apply(this, arguments);
    };
  }();
  this.relayTx = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(sourceChainId, targetChainId, txHash, signer) {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _this.relayTxs(sourceChainId, targetChainId, [txHash], signer);
          case 2:
            return _context7.abrupt("return", _context7.sent);
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x17, _x18, _x19, _x20) {
      return _ref9.apply(this, arguments);
    };
  }();
  this.relayTxs = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(sourceChainId, targetChainId, txHashes, signer) {
      var rpc, sourceBridgeContract, receiptProofs, logs, bridgeRequests, tx;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _this.getChainRpc(sourceChainId);
          case 2:
            rpc = _context8.sent;
            _context8.next = 5;
            return _this.getBridgeContract(sourceChainId, rpc);
          case 5:
            sourceBridgeContract = _context8.sent;
            _context8.next = 8;
            return Promise.all(txHashes.map(function (txHash) {
              return SignUtils.receiptProof(txHash, rpc, sourceChainId);
            })).catch(function (e) {
              throw new Error("receiptProof failed: ".concat(e.message));
            });
          case 8:
            receiptProofs = _context8.sent;
            logs = (0, lodash_1.flatten)(receiptProofs.map(function (receiptProof) {
              receiptProof['logs'] = receiptProof.receipt.logs.map(function (log) {
                try {
                  return sourceBridgeContract.interface.parseLog(log);
                } catch (e) {
                  return {};
                }
              });
              return receiptProof['logs'];
            }));
            bridgeRequests = logs.filter(function (_) {
              return _.name === 'BridgeRequest';
            }).map(function (_) {
              return (0, lodash_1.pick)(_.args, ['from', 'to', 'amount']);
            });
            _context8.next = 13;
            return _this.submitBlocksAndExecute(sourceChainId, targetChainId, receiptProofs, signer).catch(function (e) {
              throw new Error("submitBlocksAndExecute failed: ".concat(e.message));
            });
          case 13:
            tx = _context8.sent;
            return _context8.abrupt("return", {
              relayTxHash: tx.hash,
              relayPromise: tx.wait(),
              bridgeRequests: bridgeRequests
            });
          case 15:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x21, _x22, _x23, _x24) {
      return _ref10.apply(this, arguments);
    };
  }();
  this.fetchLatestCheckpointBlock = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(sourceChainId) {
      var latestCheckpointFilter, events, bestBlock;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            latestCheckpointFilter = _this.registryContract.filters.BlockAdded(null, sourceChainId);
            _context9.next = 3;
            return _this.registryContract.queryFilter(latestCheckpointFilter, -(_this.registryBlockFrequency * 10));
          case 3:
            events = _context9.sent;
            bestBlock = (0, lodash_1.maxBy)(events, function (_) {
              return _.args.blockNumber;
            });
            if (!bestBlock) {
              _context9.next = 7;
              break;
            }
            return _context9.abrupt("return", bestBlock.args.blockNumber.toNumber());
          case 7:
            throw new Error("no recent checkpoint block for chain ".concat(sourceChainId));
          case 8:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x25) {
      return _ref11.apply(this, arguments);
    };
  }();
  this.fetchPendingBridgeRequests = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(sourceChainId, targetChainId, fromBlock) {
      var maxBlocks,
        maxRequests,
        _a,
        _b,
        bridge,
        targetBridge,
        targetMulti,
        multicallProvider,
        checkpointBlock,
        fetchEventsFromBlock,
        STEP,
        lastProcessedBlock,
        events,
        targetEvents,
        maxEvents,
        lastBlock,
        ids,
        idsResult,
        unexecutedIds,
        validEvents,
        lastValidBlock,
        _args10 = arguments;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            maxBlocks = _args10.length > 3 && _args10[3] !== undefined ? _args10[3] : 10000;
            maxRequests = _args10.length > 4 && _args10[4] !== undefined ? _args10[4] : 100;
            _context10.next = 4;
            return _this.getBridgeContract(sourceChainId);
          case 4:
            bridge = _context10.sent;
            _context10.next = 7;
            return _this.getBridgeContract(targetChainId);
          case 7:
            targetBridge = _context10.sent;
            targetMulti = new ethers_multicall_1.Contract(targetBridge.address, ['function executedRequests(uint256) view returns(bool)']);
            multicallProvider = new ethers_multicall_1.Provider(targetBridge.provider, targetChainId);
            _context10.next = 12;
            return _this.fetchLatestCheckpointBlock(sourceChainId).catch(function (e) {
              throw new Error("fetchLatestCheckpointBlock failed ".concat(sourceChainId, " ").concat(e.message));
            });
          case 12:
            checkpointBlock = _context10.sent;
            fetchEventsFromBlock = fromBlock || Math.max(checkpointBlock - 20000, 0);
            STEP = 5000;
            lastProcessedBlock = Math.min(fetchEventsFromBlock + maxBlocks, checkpointBlock);
            _context10.t0 = (0, lodash_1.flatten);
            _context10.next = 19;
            return (0, p_all_1.default)((0, lodash_1.range)(fetchEventsFromBlock, lastProcessedBlock + 1, STEP).map(function (startBlock) {
              return function () {
                var toBlock = Math.min(startBlock + STEP, lastProcessedBlock);
                return bridge.queryFilter('BridgeRequest', startBlock, toBlock).catch(function () {
                  throw new Error("queryFilter BridgeRequest failed ".concat(sourceChainId, " startBlock=").concat(startBlock, " toBlock=").concat(toBlock));
                });
              };
            }), {
              concurrency: 5
            });
          case 19:
            _context10.t1 = _context10.sent;
            events = (0, _context10.t0)(_context10.t1);
            targetEvents = events.filter(function (_) {
              return _.args.targetChainId.toNumber() === targetChainId;
            });
            maxEvents = targetEvents.slice(0, maxRequests);
            lastBlock = ((_a = (0, lodash_1.last)(maxEvents)) === null || _a === void 0 ? void 0 : _a.blockNumber) || 0;
            maxEvents.push.apply(maxEvents, _toConsumableArray(targetEvents.slice(maxRequests).filter(function (_) {
              return _.blockNumber === lastBlock;
            })));
            ids = maxEvents.map(function (_) {
              return _.args.id;
            });
            _context10.t2 = (0, lodash_1.flatten);
            _context10.next = 29;
            return (0, p_all_1.default)((0, lodash_1.chunk)(ids, 500).map(function (idsChunk) {
              return function () {
                var calls = idsChunk.map(function (id) {
                  return targetMulti.executedRequests(id);
                });
                return multicallProvider.all(calls).catch(function () {
                  throw new Error("multicallProvider failed ".concat(calls.length, " multicall=").concat(targetMulti.address, " sample ids:").concat(idsChunk.slice(0, 10)));
                });
              };
            }), {
              concurrency: 5
            });
          case 29:
            _context10.t3 = _context10.sent;
            idsResult = (0, _context10.t2)(_context10.t3);
            unexecutedIds = ids.filter(function (v, i) {
              return idsResult[i] === false;
            });
            validEvents = maxEvents.filter(function (e) {
              return unexecutedIds.includes(e.args.id);
            });
            validEvents = validEvents.filter(function (_) {
              return _.blockNumber <= validEvents[0].blockNumber + 50;
            });
            lastValidBlock = ((_b = (0, lodash_1.last)(validEvents)) === null || _b === void 0 ? void 0 : _b.blockNumber) || 0;
            lastProcessedBlock = validEvents.length === 0 ? lastProcessedBlock : lastValidBlock;
            return _context10.abrupt("return", {
              validEvents: validEvents,
              checkpointBlock: checkpointBlock,
              lastProcessedBlock: lastProcessedBlock,
              fetchEventsFromBlock: fetchEventsFromBlock
            });
          case 37:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x26, _x27, _x28) {
      return _ref12.apply(this, arguments);
    };
  }();
  this.registryContract = new ethers_1.ethers.Contract(registryAddress, BlockHeaderRegistry_json_1.abi, new providers_1.JsonRpcBatchProvider(registryRpc));
  this.registryBlockFrequency = registryBlockFrequency;
  this.bridges = _objectSpread(_objectSpread({}, DEFAULT_BRIDGES), bridges);
  Object.entries(multicalls).map(function (pair) {
    return (0, ethers_multicall_1.setMulticallAddress)(Number(pair[0]), pair[1]);
  });
  this.logger = logger;
  this.rpcs = rpcs;
});
exports.BridgeSDK = BridgeSDK;